import { render } from "./ModalSessionPublicWarning.vue?vue&type=template&id=79ba0226"
import script from "./ModalSessionPublicWarning.vue?vue&type=script&lang=js"
export * from "./ModalSessionPublicWarning.vue?vue&type=script&lang=js"

import "./ModalSessionPublicWarning.vue?vue&type=style&index=0&id=79ba0226&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__